import { __extends } from 'tslib';
import web2clientSounds from '@lst/web2clientapi/sound';
import classNames from 'classnames';
import * as React from 'react';
import { t } from '../../localization.js';
import Label from '../Label/Label.js';
import Spinner from '../Spinner/Spinner.js';
import styles from './Input.module.scss.js';

var Input = (function (_super) {
    __extends(Input, _super);
    function Input(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (event) {
            if (_this.props.onChange) {
                _this.props.onChange(event);
            }
            web2clientSounds.playInputSound();
        };
        _this.inputRef = function (c) {
            if (_this._input && _this.props.noimesupport) {
                _this._input.setAttribute('noimesupport', '');
            }
            return '';
        };
        return _this;
    }
    Input.prototype.componentDidMount = function () {
        if (this.props.isFocusOn) {
            this._input.focus();
        }
    };
    Input.prototype.render = function () {
        var _a, _b, _c;
        var _this = this;
        var classNameContainer = classNames(styles.container, (_a = {},
            _a[styles.isDisabled] = this.props.isDisabled,
            _a));
        var classNameInner = classNames(styles.inner, (_b = {},
            _b[styles.isInlined] = this.props.isInlined,
            _b));
        var classNameInput = classNames(styles.input, (_c = {},
            _c[styles.isErrored] = this.props.error,
            _c[styles.isTextCentered] = this.props.isTextCentered,
            _c));
        var renderLabel;
        var renderValidator;
        var renderError;
        var renderHelp;
        var renderInfo;
        var renderCounter = null;
        if (this.props.label) {
            renderLabel = React.createElement(Label, null, this.props.label);
        }
        if (this.props.isValidating) {
            renderValidator = (React.createElement("div", { className: styles.validator },
                React.createElement(Spinner, null),
                t('Проверка:валидация')));
        }
        else if (this.props.error) {
            renderError = React.createElement("div", { className: styles.error }, this.props.error);
        }
        if (this.props.help) {
            renderHelp = React.createElement("div", { className: styles.help }, this.props.help);
        }
        if (this.props.info) {
            renderInfo = React.createElement("div", { className: styles.info }, this.props.info);
        }
        if (this.props.isCounted) {
            var valueLen = this.props.value.length;
            renderCounter = (React.createElement("div", { className: styles.counter },
                React.createElement("span", { className: styles.counterCurrent }, valueLen),
                " / ",
                this.props.maxLength));
        }
        return (React.createElement("div", { className: classNames(classNameContainer, this.props.className) },
            renderLabel,
            React.createElement("div", { className: classNameInner },
                React.createElement("input", { className: classNameInput, disabled: this.props.isDisabled, maxLength: this.props.maxLength, placeholder: this.props.placeholder, style: { width: this.props.width }, type: this.props.type || 'text', name: this.props.name, value: this.props.value, onBlur: this.props.onBlur, onChange: this.onChange, onFocus: this.props.onFocus, onKeyPress: this.props.onKeyPress, onKeyDownCapture: function (e) {
                        if (_this.props.onKeyDownCapture !== undefined && _this.props.onKeyDownCapture !== null) {
                            _this.props.onKeyDownCapture(e);
                        }
                    }, ref: this.inputRef, spellCheck: false }),
                renderValidator,
                renderError,
                renderHelp,
                renderInfo,
                renderCounter)));
    };
    return Input;
}(React.PureComponent));

export { Input as default };
//# sourceMappingURL=Input.js.map
